import { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { isEqual } from 'lodash'

import { Button, CircularProgress, Stack, TextField, Box } from '@mui/material'
import ToastAlert from '../../../../../core/Layouts/ToastAlert'
import SideDialog from '../../../../dis/components/SideDialog'
import EmployeeSummaryForm from './EmployeeSummaryForm'

export default function EmployeeSettingDialog(props) {
	const {
		tileElementWidth,
		defaultTileWidth,
		tile,
		open,
		settings,
		isSubmitting,
		showStable,
		onClose,
		onSubmit,
		onResizeTileWidth,
		dashboardKeyList,
	} = props

	const { t } = useTranslation('common')
	const { id: dashboardKey } = useParams()

	const [alertInfo, setAlertInfo] = useState({
		open: false,
		text: '',
		type: 'success',
	})

	const [filterData, setFilterData] = useState({})

	const dialogWidth = tile?.w ?? 6
	const STABLE_WIDTH = 6

	useEffect(() => {
		if (isEqual(settings?.customemizedGroupName, filterData?.customemizedGroupName)) return
		if (settings?.customemizedGroupName) {
			setFilterData((prev) => ({ ...prev, customemizedGroupName: settings?.customemizedGroupName }))
		}
	}, [settings?.customemizedGroupName])

	useEffect(() => {
		if (isEqual(settings?.projectFormInfo, filterData?.projectFormInfo)) return
		if (settings?.projectFormInfo) {
			setFilterData((prev) => ({ ...prev, projectFormInfo: settings?.projectFormInfo }))
		}
	}, [settings?.projectFormInfo])

	useEffect(() => {
		if (isEqual(settings?.schedulerRangeType, filterData?.schedulerRangeType)) return
		if (settings?.schedulerRangeType) {
			setFilterData((prev) => ({ ...prev, schedulerRangeType: settings?.schedulerRangeType }))
		}
	}, [settings?.schedulerRangeType])

	useEffect(() => {
		if (isEqual(settings?.schedulerStartTime, filterData?.schedulerStartTime)) return
		if (settings?.schedulerStartTime) {
			setFilterData((prev) => ({ ...prev, schedulerStartTime: settings?.schedulerStartTime }))
		}
	}, [settings?.schedulerStartTime])

	useEffect(() => {
		if (isEqual(settings?.schedulerEndTime, filterData?.schedulerEndTime)) return
		if (settings?.schedulerEndTime) {
			setFilterData((prev) => ({ ...prev, schedulerEndTime: settings?.schedulerEndTime }))
		}
	}, [settings?.schedulerEndTime])

	useEffect(() => {
		if (isEqual(settings?.schedulerColorStatusSettings, filterData?.schedulerColorStatusSettings))
			return
		if (settings?.schedulerColorStatusSettings) {
			setFilterData((prev) => ({
				...prev,
				schedulerColorStatusSettings: settings?.projschedulerColorStatusSettingsectFormInfo,
			}))
		}
	}, [settings?.schedulerColorStatusSettings])

	useEffect(() => {
		if (isEqual(settings?.otherOptionsChecked, filterData?.otherOptionsChecked)) return
		if (settings?.otherOptionsChecked) {
			setFilterData((prev) => ({ ...prev, otherOptionsChecked: settings?.otherOptionsChecked }))
		}
	}, [settings?.otherOptionsChecked])

	useEffect(() => {
		if (isEqual(settings?.migrateOtherOptions, filterData?.migrateOtherOptions)) return
		if (settings?.migrateOtherOptions) {
			setFilterData((prev) => ({ ...prev, migrateOtherOptions: settings?.migrateOtherOptions }))
		}
	}, [settings?.migrateOtherOptions])

	useEffect(() => {
		if (isEqual(settings?.linkedFields, filterData?.linkedFields)) return
		if (settings?.linkedFields) {
			setFilterData((prev) => ({ ...prev, linkedFields: settings?.linkedFields }))
		}
	}, [settings?.linkedFields])

	useEffect(() => {
		if (isEqual(settings?.modalDashboardSetting, filterData?.modalDashboardSetting)) return
		if (settings?.modalDashboardSetting) {
			setFilterData((prev) => ({ ...prev, modalDashboardSetting: settings?.modalDashboardSetting }))
		}
	}, [settings?.modalDashboardSetting])

	useEffect(() => {
		if (isEqual(settings?.mapModalDashboardSetting, filterData?.mapModalDashboardSetting)) return
		if (settings?.mapModalDashboardSetting) {
			setFilterData((prev) => ({
				...prev,
				mapModalDashboardSetting: settings?.mapModalDashboardSetting,
			}))
		}
	}, [settings?.mapModalDashboardSetting])

	useEffect(() => {
		if (isEqual(tile?.type, filterData?.type)) return
		if (tile?.type) {
			setFilterData((prev) => ({ ...prev, type: tile?.type }))
		}
	}, [tile?.type])

	const handleSubmit = () => {
		// if (!filterData || !filterData?.selectedTaskMapForm) {
		// 	setAlertInfo((prev) => ({
		// 		...prev,
		// 		open: true,
		// 		type: 'error',
		// 		text: t('common:dis.pleaseFillInformation'),
		// 	}))
		// 	return
		// }

		onSubmit?.({
			customemizedGroupName: filterData?.customemizedGroupName,
			projectFormInfo: filterData?.projectFormInfo,
			schedulerRangeType: filterData?.schedulerRangeType,
			schedulerStartTime: filterData?.schedulerStartTime,
			schedulerEndTime: filterData?.schedulerEndTime,
			schedulerColorStatusSettings: filterData?.schedulerColorStatusSettings,
			otherOptionsChecked: filterData?.otherOptionsChecked,
			migrateOtherOptions: filterData?.migrateOtherOptions,
			linkedFields: filterData?.linkedFields,
			modalDashboardSetting: filterData?.modalDashboardSetting,
			mapModalDashboardSetting: filterData?.mapModalDashboardSetting,
		})
		onClose()
	}

	const handleFilterDataChange = (id, value) => {
		setFilterData((prev) => ({ ...prev, [id]: value }))
	}
	return (
		<>
			<ToastAlert alertInfo={alertInfo} setAlertInfo={setAlertInfo} />

			<SideDialog
				open={open}
				onClose={onClose}
				width={showStable ? STABLE_WIDTH : dialogWidth}
				tileElementWidth={tileElementWidth}
				onResizeWidth={onResizeTileWidth}
				defaultTileWidth={defaultTileWidth}
			>
				<Stack
					sx={{
						'& .MuiInputBase-input': {
							fontSize: '0.9rem !important',
						},
						'& .MuiCheckbox-root': {
							p: 0,
						},
					}}
				>
					<Box sx={{ px: 1, mb: '15px' }}>
						<TextField
							fullWidth
							id="label-basic"
							label={t('common:chart.labels')}
							variant="standard"
							value={tile.i}
							disabled={true}
							size="small"
						/>
					</Box>

					<EmployeeSummaryForm
						filterData={filterData}
						onFilterDataChange={handleFilterDataChange}
						dashboardKeyList={dashboardKeyList}
					/>

					<Stack direction="row" justifyContent="flex-end" mt={2}>
						<Stack spacing={2} direction="row">
							<Button
								size="small"
								variant="contained"
								onClick={handleSubmit}
								disabled={isSubmitting}
								startIcon={isSubmitting ? <CircularProgress color="inherit" size="1em" /> : null}
							>
								{t('common:misc.ok')}
							</Button>
							<Button size="small" variant="text" onClick={onClose}>
								{t('common:misc.cancel')}
							</Button>
						</Stack>
					</Stack>
				</Stack>
			</SideDialog>
		</>
	)
}
